import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExportarService {

  constructor(private http: HttpClient) { }

  index(): Observable<[]> {
    return this.http.get<[]>(environment.apiUrl + '/exportar');
  }

  downloadFile(tipo: number): Observable<HttpResponse<Blob>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.get(environment.apiUrl + '/exportar/' + tipo, {
      responseType: 'blob',
      headers: headers,
      observe: 'response'
    });
  }

  login(model: {}): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    return this.http.post<{}>(environment.apiUrl + '/exportar',
      model,
      { headers: headers }
    );
  }
}
